export default "__VITE_ASSET__DYvggk$$__"